<script lang="ts">
  import { Label } from "sveltestrap";
  import { Subtotal } from "../../../../utils/Constant/Constant";
  import {getCartTotal} from "../../../../Data/Ecommerce/Cartdata"
  import {cart} from "../../../../store"
  let setCart:any
  cart.subscribe((value)=>{
    setCart = value
  })

</script>
<ul class="sub-total">
    <li>{Subtotal} 
      <span class="count">$ {getCartTotal(setCart)}</span>
    </li>
    <li class="shipping-class">{'Shipping'}
      <div class="shopping-checkout-option">
        <Label class="d-block" for="chk-ani">
          <input class="checkbox_animated" id="chk-ani" type="checkbox" checked />{'Option 1'}
        </Label>
        <Label class="d-block" for="chk-ani1">
          <input class="checkbox_animated" id="chk-ani1" type="checkbox"/>{'Option 2'}
        </Label>
      </div>
    </li>
</ul>
<ul class="sub-total total">
    <li>{'Total'} 
      <span class="count">$ {getCartTotal(setCart)}</span>
    </li>
</ul>